export const ModalActionUnlock = ({ btnAction, btnCancel }: any) => {
  return (
    <>
      <h4 className="text-capitalize mb-3">Unlock Time Entry</h4>
      <p className="color-neutrals-800">
        Are you sure you want to unlock these time entries? They will be set to
        Pending.
      </p>
      <div className="d-flex mt-3">
        <button className="btn button-secondary w-100" onClick={btnCancel}>
          Cancel
        </button>
        <button
          className="btn btn-primary w-100 ms-2"
          onClick={() => btnAction(7, null)}
        >
          Save
        </button>
      </div>
    </>
  );
};
